import { BreakpointsContext } from '@centra/ui-global-context';
import { useContext, useEffect, useState } from 'react';

/**
 * Хук, актуален только для мобилки, который решает ряд проблем при появлении мобильной клавиатуры
 *
 * `!!!Важно для корректной работы на IOS необходимо чтобы:`
 * - основной контейнер был абсолютно спозиционирован относительно html тега
 * - основной контейнер были прибит к дну html тега, т.е bottom = 0
 *
 * @param defaultElementHeight начальное состояние высоты для основного контейнера с содержимым
 * @returns значение высоты контейнера
 */
export const useViewPortMobileKeyboard = ({
  defaultElementHeight = 'auto',
  forceSetHeight,
}: {
  defaultElementHeight: string;
  forceSetHeight?: boolean;
}) => {
  const { isMobile } = useContext(BreakpointsContext);
  const [elementHeight, setElementHeight] = useState<string>(defaultElementHeight);

  useEffect(() => {
    if (!isMobile) {
      document.getElementsByTagName('html')[0].style.height = '';
    }

    if (window !== undefined && window.visualViewport) {
      const handler = () => {
        const fullHeight = window.visualViewport ? `${window.visualViewport.height}px` : 'auto';
        document.getElementsByTagName('html')[0].style.height = fullHeight;
        setElementHeight(fullHeight);
      };

      window.visualViewport.addEventListener('resize', handler);
      if (forceSetHeight) handler();

      return () => {
        document.getElementsByTagName('html')[0].style.height = '';
        window.visualViewport?.removeEventListener('resize', handler);
      };
    }
  }, [forceSetHeight, isMobile]);

  return elementHeight;
};
